/* eslint-disable camelcase */
import jwt_decode from 'jwt-decode';

const hasValidToken = () => {
    const { token, exp } = { ...localStorage };
    if (token && exp) {
        if (exp < new Date().getTime() / 1000) {
            return false;
        }
        return true;
    }
    return false;
};

const getDefaultRouteForUser = () => {
    const { token } = { ...localStorage };
    const decodedToken = jwt_decode(token);

    // Clinics and labs should see the cases page
    if (decodedToken?.clinic_id || decodedToken?.lab_id) {
        return '/cases';
    }

    // Org admins should see the dashboard
    if (decodedToken?.organization_id) {
        return '/dashboard';
    }

    // Admins should see the dashboard
    return '/dashboard';
};

const getDefaultRoute = () => {
    if (!hasValidToken()) {
        localStorage.clear();
        return null;
    }

    try {
        const defaultRouteForUser = getDefaultRouteForUser();
        return defaultRouteForUser || '/cases';
    } catch (error) {
        localStorage.clear();
        return null;
    }
};

export default getDefaultRoute;
